import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { Observable } from 'rxjs/Rx';
import { Router } from '@angular/router';

import { GroupViewModel } from '../../../model/GroupViewModel';
import { RolesViewModel } from '../../../model/RolesViewModel';
import { GroupsToUserViewModel } from '../../../model/GroupsToUserViewModel';
import { AppSettingsService } from '../appsettings.service';
import { AuthService } from '../authentication.service';
import { RequestResult } from '../../../model/RequestResult';

@Injectable()
export class GroupService {
    constructor(protected router: Router, private authHttp: AuthService, private settings: AppSettingsService) { }

    getRightsList(): Promise<RolesViewModel[]> {
        let url = this.settings.getAppSetting('apiUri') + 'groups/getRights';
        return this.authHttp.authGet(url).then(response => {
            let rightList: Array<RolesViewModel> = JSON.parse(<string>response.data);
            return rightList;
        }).catch(this.handleError);
    }

    getGroupList(): Promise<GroupsToUserViewModel[]> {
        let url = this.settings.getAppSetting('apiUri') + 'groups/get';
        return this.authHttp.authGet(url).then(response => {
            let groupList: Array<GroupsToUserViewModel> = JSON.parse(<string>response.data);
            return groupList;
        }).catch(this.handleError);
    }

    getEditGroup(id: string): Promise<GroupViewModel> {
        let url = this.settings.getAppSetting('apiUri') + 'groups/edit';

        let params: URLSearchParams = new URLSearchParams();

        if (id == null) {
            id = '';
        }
        params.set('id', id);

        return this.authHttp.authGetWithParam(url, params).then(response => {
            let group: GroupViewModel = JSON.parse(<string>response.data);
            return group;
        }).catch(this.handleError);
    }

    updateGroup(group: GroupViewModel): Promise<RequestResult> {
        let url = this.settings.getAppSetting('apiUri') + 'groups/save';
        return this.authHttp.authPost(url, group).then(response => {
            this.authHttp.refreshUserRights();
            this.router.navigate(['/group/groupoverview']);
            return response;
        });
    }

    addGroup(group: GroupViewModel): Promise<RequestResult> {
        return this.updateGroup(group);
    }

    deleteGroup(id: string): Promise<RequestResult> {
        let url = this.settings.getAppSetting('apiUri') + 'groups/delete?id=' + id;
        return this.authHttp.authDelete(url);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }
}


// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./~/source-map-loader!./~/tslint-loader!./angularApp/app/shared/services/group/group.service.ts